module.exports = __webpack_public_path__ + "img/up_arrow_icon.2ad407dc.svg";